import en               from '../language/en'
import es               from '../language/es'

const languages = {E: en, S: es}

export default languages


// WEBPACK FOOTER //
// ./client/app/language/index.js